import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { PostListItem } from 'src/app/shared/interfaces/post/post-list-item.interface'
import { RouterModule } from '@angular/router'
import { TruncatePipe } from 'src/app/shared/pipes/truncate.pipe'
import { DateagoPipe } from 'src/app/shared/pipes/dateago.pipe'
import { ButtonComponent } from '../../../../../shared/components/form-elements/button/button.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { PostsStore } from '../../posts.store'
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight'
import { StaffListItem } from 'src/app/shared/interfaces/staff/staff-list-item.interface'
import { FormsModule } from '@angular/forms'
import { environment } from 'src/environments/environment'
import { ConfirmationDialogService } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.service'
import { NgxPermissionsModule } from 'ngx-permissions'
import { AppStore } from 'src/app/core/app.store'
import { NotesDirective } from 'src/app/shared/components/notes/notes.directive'

@Component({
    selector: 'sf-post-detail',
    imports: [
        FormsModule,
        RouterModule,
        FontAwesomeModule,
        NgbTooltipModule,
        NgOptionHighlightModule,
        NgbDropdownModule,
        NgSelectModule,
        NgxPermissionsModule,
        ButtonComponent,
        NotesDirective,
        DateagoPipe,
        TruncatePipe,
        DatePipe,
    ],
    templateUrl: './post-detail.component.html',
    styleUrls: ['./post-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostDetailComponent {
    private confirmationService = inject(ConfirmationDialogService)
    appStore = inject(AppStore)
    postStore = inject(PostsStore)

    legacyUrl = environment.legacyUrl

    @Input() post!: PostListItem

    @Output() onPostClick = new EventEmitter<PostListItem>()
    @Output() onViewCertificate = new EventEmitter<PostListItem>()

    postClick(): void {
        this.onPostClick.emit(this.post)
    }

    viewCertificate() {
        this.onViewCertificate.emit(this.post)
    }

    assignPostToStaff(staff: StaffListItem): void {
        if (staff) {
            this.postStore.assignPostToStaffId({ postId: this.post.id, staffId: staff.id })
        } else {
            this.postStore.unassignPost(this.post.id)
        }
    }

    takePost() {
        this.postStore.assignPostToStaffId({ postId: this.post.id, staffId: this.appStore.me()!.id })
    }

    unTakePost() {
        this.postStore.unassignPost(this.post.id)
    }

    deletePost(): void {
        this.confirmationService.confirm('Are you sure?', 'Deleting this post cannot be undone').then((result) => {
            if (result) {
                this.postStore.deletePost(this.post.id)
            }
        })
    }
}
